import * as React from 'react';

import { cn } from '@/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          `
  flex
  h-12
  w-full
  rounded-full
  border
  border-[#616161]
  bg-transparent

  px-4
  py-2

  text-sm
  text-white

  placeholder:text-[#7a7a7a]

  transition-all
  duration-200

  outline-none

  focus:border-[#FA5629]
  focus:ring-2
  focus:ring-[#FA5629]/20

  focus-visible:outline-none

  disabled:cursor-not-allowed
  disabled:opacity-50

  file:border-0
  file:bg-transparent
  file:text-sm
  file:font-medium
  `,
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
